const demo_app = {
    notification: 'ヒント：最初にアカウントを作成してサインイン体験をテストしてください。',
};
export default Object.freeze(demo_app);
